export default "__VITE_ASSET__CYfNUfbe__"